export const removeHtmlTags = (input) => {
  let prev
  do {
    prev = input
    input = input.replace(/<[^>]*>/g, '')
  } while (input !== prev)
  return input.trim()
}
